import { makeStyles } from '@material-ui/core'

const styles = (primaryColor) =>
  makeStyles((theme) => ({
    avatar: {
      backgroundColor: primaryColor || theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: theme.spacing(1),
      width: 70,
      height: 35,
    },
  }))

export default styles
